// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__pWDXo","row":"ProcedureTreatmentSummary_row__2WBL7"};